module.exports = __webpack_public_path__ + "img/hockey-puck.64f4891e.svg";